import { render } from "./ProductListItem.vue?vue&type=template&id=a49f6b2a&scoped=true&ts=true"
import script from "./ProductListItem.vue?vue&type=script&lang=ts"
export * from "./ProductListItem.vue?vue&type=script&lang=ts"

import "./ProductListItem.vue?vue&type=style&index=0&id=a49f6b2a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a49f6b2a"]])

export default __exports__